module.exports.parse = function(data) {
    let startRcp = false;
    let startTransactions = false;
    let startCorrection = false;
    let startPayments = false;
    let endRcp = false;
    let rcpHash = '';
    let hashParts = 0;

    /** @type { Receipt[] } */
    let Receipts = [];

    let tempRcp;

    //console.log(data);
    if (!data) {
        return [];
    }
    data = data.split('\n');
    let tempArticle = new Article();
    let tempPayment = new Payment();
    let tempChange = new Change();

    for (let i = 0; i < data.length; i++) {

        let tempLine = data[i];
        //Проверка за край
        if (tempLine === '@') {
            break;
        }
        if (tempLine.includes('\r')) {
            tempLine = tempLine.replace(/\r/gm, "");
        }

        //Пропускане на празните редове
        //Пропускане на редовете със *
        if (tempLine.match(/^(?:\x20)*$/gim) ||
            tempLine.match(/^[(\x20)+(\x2A+)]+$/gim)) {
            continue;
        }
        //Проверка за край на транзакциите, което значи начало на плащанията
        //Редът започва с /Обща сума/ 0x5F символи и сумата в края
        //Пример - Обща сума   15.98
        if (tempLine.match(/^Обща сума(?:\x5F)*\d+\.\d{2}$/gim)) {
            startPayments = true;
            startTransactions = false;
            tempRcp.totalSum = tempLine.split(/(?:\x5F)/).pop();
            continue;
        }
        //Намираме се около края на бележката
        //редът оказващ края на бележката  започва с
        //число показващо колко е броя на продажбите и думата /Артикула/
        //Пример -                 8 Артикула
        if (tempLine.match(/^\x20+\d+\x20Артикула$/gim)) {
            startPayments = false;
            endRcp = true;
            continue;
        }
        if (tempLine.match(/^(?:\x20)*\d{6}(?:\x20)*\d*(?:\x20)*Артикула(?:\x20)*$/gim)) {
            tempLine = tempLine.replace(/(?:\x20)*\d+\x20Артикула$/gim, '');
            tempRcp.rcpNum = tempLine.trim();
            startPayments = false;
            endRcp = true;
            continue;
        }
        //При фискален принтер с широка хартия - номер на бон, дата и час, брой артикули 
        //са на един ред. За това премахваме броя артикули изкуствено, за да сработи другата логика.
        if (tempLine.match(/^\d{6}(?:\x20)*\d{2}-\d{2}-\d{4}\x20+\d{2}:\d{2}:\d{2}(?:\x20)+\d+\x20Артикула$/gim)) {
            tempLine = tempLine.replace(/(?:\x20)*\d+\x20Артикула$/gim, '');
            startPayments = false;
            endRcp = true;
        }
        //Проверка за ред съдържащ ФАКТУРА N спейсове и номер на фактурата, който е 10 символа
        if (tempLine.match(/^(?:\x20)*ФАКТУРА N(?:\x20)*[0-9]{10}(?:\x20)*$/gim)) {
            let filtered = tempLine.split(' ').filter((elem) => elem != '');
            tempRcp.invNumber = filtered.pop();
            tempRcp.invoice = true;
        }

        if (tempLine.match(/^(?:\x20)*СТОРНО БОН(?:\x20)*[0-9]{10}(?:\x20)*$/gim) ||
            tempLine.match(/^(?:\x20)*КРЕДИТНО ИЗВЕСТИЕ(?:\x20)*[0-9]{10}(?:\x20)*$/gim)) {
            tempRcp.storno = true;
        }

        if (!startRcp) {
            //Проверка за старт на бон. Проверява дали даденият ред
            //започва със символ "#", 4 цифри, спейсове и след тях името на оператора
            //0001 Чичо Стефчо - пример
            if (tempLine.match(/^#\d{4}[\dА-я\s]*$/gim)) {
                tempRcp = new Receipt();
                startRcp = true;
                startTransactions = true;
                tempRcp.opNum = tempLine.substring(1, 5);
                tempRcp.opName = tempLine.substring(5, tempLine.length - 3).trim();
                continue;
            }
        } else if (tempLine.match(/^УНП:(\x20)*ZK\d{6}-[A-Za-z0-9]{4}-[A-Za-z0-9]{7}(\x20)*$/gim)) {
            //Проверка за УНП номер на бон
            //Пример УНП:  ZK123456-1234-1234567
            startTransactions = true;
            tempRcp.unp = tempLine.substring(4).trim();
            continue;
        } else if (startTransactions) {
            //Първо проверяваме дали дадения не е направена корекция на артикула
            if (tempLine.match(/^(\x20)+КОРЕКЦИЯ(\x20)+$/gim)) {
                startCorrection = true;
                tempArticle.voidFlag = startCorrection;
                continue;
            }
            //Проверява ред за транзакция, който съдържа:
            //количество спейс Х спейс цена
            //Пример -                    1.200 X 1.00
            if (tempLine.match(/^(?:\x20)*(\d+\.\d{3}) X (\d+\.\d{2})$/gim)) {
                let tmp = tempLine.split(' X ');
                tempArticle.qty = tmp[0].trim();
                tempArticle.price = tmp[1].trim();
                continue;
            }
            //Проверка за ред, съдържащ сумата на транзакцията
            //Редът съдържа: думата /Сума/, *, буква за Данъчна група,
            //символи 0x5F и крайната цена на транзакцията
            //Пример - Сума*Б1.20
            //При намиране на такъв ред се добавя артикула в масива с артикули Articles
            //и се зачиства tempArticle променливата
            else if (tempLine.match(/^Сума\*[АБВГДЕЖЗ]{1}(?:\x5F)*\d+\.\d{2}$/gim)) {
                tempArticle.taxgr = tempLine.slice(5, 6).trim();

                tempArticle.artTotalSum = tempLine.split(/(?:\x5F)/).pop();
                if (!tempArticle.price) {
                    tempArticle.price = (Number(tempArticle.artTotalSum) / Number(tempArticle.qty)).roundTo(2).toFixed(2);
                }
                tempRcp.articles.push(tempArticle);
                tempArticle = new Article();
                continue;
            }
            //Проверка за ред, съдържащ количеството, единичната цена, общата сума и данъчната група
            //Такъв ред може да се появи при ФП с широка хартия
            //Пример -    2.000 X      5.50               11.00 В
            //При намиране на такъв ред се добавя артикула в масива с артикули
            //и се зачиства tempArticle променливата
            else if (tempLine.match(/^(?:\x20)+\d+\.\d{3}(?:\x20)+X(?:\x20)+\d+\.\d{2}(?:\x20)+\d+\.\d{2}(?:\x20)+[АБВГДЕЖЗ]{1}$/gim)) {
                let filtered = tempLine.split(' ').filter((elem) => elem != '');
                tempArticle.qty = filtered[0];
                tempArticle.price = filtered[2];
                tempArticle.taxgr = filtered[4];
                tempArticle.artTotalSum = filtered[3];
                tempRcp.articles.push(tempArticle);
                tempArticle = new Article();
            }
            //Проверка за ред, съдържащ количеството над транзакцията 
            //Пример - Количество3.52
            //Такъв ред се среща при разширен тип бонове
            else if (tempLine.match(/^Количество(?:\x5F)*\d+\.\d{3}$/gim)) {
                tempArticle.qty = tempLine.split(/(?:\x5F)/).pop();
                continue;
            }
            //Проверка за ред, съдържащ единичната цена над транзакцията 
            //Пример - Ед.цена   2.39
            //Пример за ФУ с широка хартия - Единична цена                 2.39
            else if (tempLine.match(/^Ед\.цена(?:\x5F)*\d+\.\d{2}$/gim) ||
                tempLine.match(/^Единична цена(?:\x5F)*\d+\.\d{2}$/gim)) {
                tempArticle.price = tempLine.split(/(?:\x5F)/).pop();
                continue;
                //Проверка за ред съдържащ спейсове, символи '~' и пак спейсове.
                //Такъв ред е флаг, че корекцията е приключила
            } else if (tempLine.match(/^(?:\x20)+(?:\x7e)+(?:\x20)+$/gim)) {
                startCorrection = false;
                continue;

            } else if (tempLine.match(/^(?:\x20)*\d{4,5}(?:\x20)+[\dА-я\s]*(?:\x20)*\d+\.\d{2}(?:\x20)*[АБВГДЕЖЗ]{1}$/gim)) {
                let tmp = tempLine.split(' ');
                let filtered = tmp.filter((elem) => elem != '');
                tempArticle.name = filtered[0] + " " + filtered[1];
                tempArticle.price = filtered[2];
                tempArticle.qty = 1;
                tempArticle.taxgr = filtered[3];
                tempArticle.artTotalSum = (Number(tempArticle.price).roundTo(2) * Number(tempArticle.qty).roundTo(3)).roundTo(2).toFixed(2);
                tempRcp.articles.push(tempArticle);
                tempArticle = new Article();
            }

            //Проверка за ред, съдържащ Отстъпка/Надбавка над транзакцията
            //Редът съдържа: Думата /Отстъпка или Надбавка/, *, буква за данъчна група,
            //спейсове стойността на Отстъпката/Надбавката, като ако има знак % то тя е процентова, иначе е стойностна,
            //и в края на реда е крайната сума
            //Пример - Надбавка*Б   1.00%          0.03
            else if (tempLine.includes("Надбавка*") || tempLine.includes("Отстъпка*")) {
                //Добавя се винаги при последният записан артикул в масива
                let lastArt = tempRcp.articles[tempRcp.articles.length - 1];
                let FlagDisc = DiscAdd.Addition;
                FlagDisc = tempLine.includes("Надбавка*") ? DiscAdd.Addition : DiscAdd.Discount;
                let flagPecr = tempLine.includes("%") ? true : false;
                lastArt.discAddFlag = FlagDisc;
                lastArt.discAddPerc = flagPecr;

                let discAddTaxGr = tempLine.substring(0, 10).split('*')[1];
                lastArt.discAddTaxGr = discAddTaxGr;
                let tmp = tempLine.substring(10).split(" ");
                let filtered = tmp.filter((elem) => elem != '');
                lastArt.discAddValue = filtered[0].includes("%") ? filtered[0].slice(0, filtered[0].length - 1) : filtered[0];
                lastArt.discAddSum = filtered[1];
                continue;
            } else {
                //Ако не е нищо от горе посочените значи е името на артикула
                tempArticle.name = tempLine.trim();
                continue;
            }
        } else if (startPayments) {
            //Примери за редове, които трябва да се пропускат
            if (tempLine.match(/^Остатък(?:\x5F)*\d+\.\d{2}$/gim) ||        //Остатък5.00
                tempLine.match(/^Всичко(?:\x5F)*\d+\.\d{2}$/gim) ||             //Всичко3.81
                tempLine.match(/^ДДС\*[АБВГДЕЖЗ]{1}(?:\x5F)*\d+\.\d{2}$/gim) || //ДДС*Б0.63
                tempLine.match(/^[АБВГДЕЖЗ]{1} = \d+\.\d{2}%(?:\x20)*$/gim) ||  //Б = 20.00%                
                tempLine.match(/^Нето ст-ст(?:\x5F)*\d+\.\d{2}$/gim) || //Нето ст-ст3.18
                tempLine.match(/^Нето стойност(?:\x5F)*\d+\.\d{2}$/gim)) {  //Нето стойност3.18
                continue;
            }
            //Ако не е от горепосочените редове, значи е плащане или ресто, символи 0x5F и сумата
            if (tempLine.match(/^[\dА-я\s:+]*(?:\x5F)*\d+\.\d{2}$/gim)) {
                if (tempLine.includes("Ресто:")) {
                    //Ако редът съдържа думата "Ресто:" записваме името и сумата в масива Changes
                    //След което зачистваме tempChange променливата
                    tempLine = tempLine.substr(6, tempLine.length - 1);
                    let s = tempLine.split(/(?:\x5F)/);
                    tempChange.name = s[0];
                    tempChange.amount = s.pop();
                    tempRcp.change.push(tempChange);
                    tempChange = new Change();
                    continue;
                } else {
                    //Ако редът не съдържа думата "Ресто:" записваме името и сумата в масива Payments
                    //След което зачистваме tempPayment променливата
                    let tmp = tempLine.split("_");
                    tempPayment.name = tmp[0];
                    tempPayment.amount = tmp.pop();
                    tempRcp.payments.push(tempPayment);
                    tempPayment = new Payment();
                    continue;
                }
            }
            if (tempRcp.invoice) {
                //Проверка за данни за фактура
                if (tempLine.toLowerCase().includes("адрес")) {
                    tempRcp.invAddress = tempLine.split(':')[1].trim();
                    continue;
                }
                if (tempLine.toLowerCase().includes("идент")) {
                    tempRcp.invUICnumber = tempLine.split(':')[1].trim();
                    continue;
                }
                if (tempLine.toLowerCase().includes("еик")) {
                    tempRcp.invUICnumber = tempLine.split(':')[1].trim();
                    continue;
                }
                if (tempLine.toLowerCase().includes("зддс")) {
                    tempRcp.invVATnumber = tempLine.split(':')[1].trim();
                    continue;
                }
                if (tempLine.toLowerCase().includes("получател")) {
                    tempRcp.invRecipient = tempLine.split(':')[1].trim();
                    continue;
                }
                if (tempLine.toLowerCase().includes("купувач")) {
                    tempRcp.invBuyer = tempLine.split(':')[1].trim();
                    continue;
                }
            }
        } else if (endRcp) {
            //Проверка за ред съдържащ дата&час
            if (tempLine.match(/^(?:\x20)*\d{2}-\d{2}-\d{4}\x20+\d{2}:\d{2}:\d{2}(?:\x20)*$/gim)) {
                let tmp = tempLine.split(' ');
                tempRcp.rcpDateTime = tmp[0] + ' ' + tmp[tmp.length - 1];
            }
            //Проверка за ред съдържащ номер на бон и дата&час
            if (tempLine.match(/^\d{6}(?:\x20)*\d{2}-\d{2}-\d{4}\x20+\d{2}:\d{2}:\d{2}$/gim)) {
                let tmp = tempLine.split(' ');
                tempRcp.rcpNum = tmp[0].trim();
                tempRcp.rcpDateTime = tmp[tmp.length - 2] + ' ' + tmp[tmp.length - 1];
            }
            //Проверка за ред, съдържащ Сериен номер и номер на ФП
            if (tempLine.match(/^ZK\d{6}(?:\x20)+\d{8}$/gim)) {
                let tmp = tempLine.split(" ");
                tempRcp.rcpSerNum = tmp[0];
                tempRcp.rcpFMnum = tmp.pop();
                continue;
            }

            //Проверка за хеш на бон за ФУ с тясна хартия - тогава хеша на 2 реда
            //Ако проверката е вярна - то тогава вдигаме флаг, че очакваме още един ред за хеш            
            if (tempLine.match(/^(?:\x20)*[A-Z0-9]{20}(?:\x20)*$/gim)) {
                rcpHash += tempLine.trim();
                hashParts++;
            }

            //Проверка за хеш на бон за ФУ с широка хартия - тогава хеша е на 1 ред
            //Ако проверката е вярна - то тогава изкуствено записваме във флага, че са минали и двата реда от хеша
            if (tempLine.match(/^(?:\x20)*[A-Z0-9]{40}(?:\x20)*$/gim)) {
                rcpHash = tempLine.trim();
                hashParts = 2;
            }

            //След като е записан хеша на бона
            //Попълваме всички данни за бона
            if (hashParts === 2) {
                tempRcp.rcpHash = rcpHash;
                hashParts = 0;
                rcpHash = '';
                endRcp = false;
                startRcp = false;
                Receipts.push(tempRcp);
                //console.log(tempRcp);
                //console.log(Articles);
                tempRcp = new Receipt();
                continue;
            }
        }
    }
    return Receipts;
};

class Receipt {
    opNum = 1;
    opName = "Оператор 1";
    invoice = false;
    storno = false;
    invNumber = null;
    invRecipient;
    invBuyer;
    invAddress;
    invUICnumber;
    invVATnumber;
    unp;
    /** @type {Article[]} */
    articles = [];
    /** @type {Payment[]} */
    payments = [];
    /** @type {Change[]} */
    change = [];
    totalSum;
    rcpNum;
    rcpDateTime;
    rcpSerNum;
    rcpFMnum;
    rcpHash;
}

class Article {
    name;
    price;
    qty = 1;
    artTotalSum;
    taxgr;
    voidFlag = false;
    discAddSum;
    discAddFlag;
    discAddPerc;
    discAddTaxGr;
}

class Payment {
    name;
    amount;
}

class Change {
    name;
    amount;
}

const DiscAdd = {
    Discount: "Discount",
    Addition: "Addition"
}